module.exports = __webpack_public_path__ + "img/cli_13.8a0f69e9.png";